import { useTranslation } from 'react-i18next';

export const TimeKeeperDoneButton = ({ onClick }: { onClick: () => void }) => {
    const { t } = useTranslation();
    return (
        <div
            style={{ textAlign: 'center', padding: '10px 0', backgroundColor: '#F4F4F4', cursor: 'pointer', borderTop: '1px solid #CCC' }}
            onClick={() => {
                if(onClick) onClick();  
            }}
        >
            {t('common.done')}
        </div>
    )
}

